import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { ICreateInterlocutor } from './interfaces/create-distribution-chain-interlocutor.interface';
import BusinessPartnerInterlocutorAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/businness-partner-interloculor/businness-partner-interloculor.entity';
import { BusinessPartnerFunctionAttributes } from '@albatrosdeveloper/ave-models-package';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { BusinessPartnerService } from '../business-partner.service';
import { BusinessPartnerFunctionService } from '../../business-partner-function/business-partner-function.service';
import { debounceTime, distinctUntilChanged, ReplaySubject, startWith, Subject, switchMap, take, takeUntil, tap } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { getCode } from 'app/utils/method';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-add-business-partner-interlocutor-modal',
  styleUrl: './distribution-chain-interlocutor.component.scss',
  templateUrl: './distribution-chain-interlocutor.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
  ],
})
export class AddInterlocutorComponent {
  getCode = getCode
  currentCreateInterlocutor: ICreateInterlocutor = this.initializeInterlocutor();
  currentUpdateBusinessPartnerChain: BusinessPartnerInterlocutorAttributes | undefined;

  businessPartnerFunctionList : BusinessPartnerFunctionAttributes[] = [];
  businessPartnerList : BusinessPartnerAttributes[] = [];
  selectedBusinessPartner: BusinessPartnerAttributes | undefined;
  businessPartnerFilterCtrl: FormControl<string> = new FormControl<string>("");
  isSearchingBusinessPartner = false;

  
    /** control for the selected function for multi-selection */
    public functionMultiCtrl: FormControl<BusinessPartnerFunctionAttributes[]> = new FormControl<
    BusinessPartnerFunctionAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public functionMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of function filtered by search keyword */
  public filteredFunction: ReplaySubject<BusinessPartnerFunctionAttributes[]> = new ReplaySubject<
    BusinessPartnerFunctionAttributes[]
  >(1);

  /** local copy of filtered function to help set the toggle all checkbox state */
  protected filteredFunctionCache: BusinessPartnerFunctionAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

 isEditMode : boolean;
 protected _onDestroy = new Subject<void>();
  constructor(
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly funcionService: BusinessPartnerFunctionService,
    public dialogRef: MatDialogRef<AddInterlocutorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Optional: if you want to pass data
    private snackBar: MatSnackBar
  ) {
    this.isEditMode = !!data;
    if (this.isEditMode) {
        this.currentCreateInterlocutor = { 
            ...data,
            businessPartnerId: data.businessPartner._id.toString(),
            businessPartnerFunctionIds: data.businessPartnerFunctions.map((functionId) => functionId._id.toString()),
            distributionChainId: data._id.toString(),
    };
        this.selectedBusinessPartner = data.businessPartner;
}
}

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


ngAfterViewInit(): void {
    // this.setupPaginationAndSorting();
    this.fetchAllBusinessPartner();
    this.fetchAllBusinessPartnerFunction();
    // this.findAllWithCount();
  }

  private fetchAllBusinessPartnerFunction(): void {
    this.funcionService.findToComboBox().subscribe({
      next: (res) => {
        this.businessPartnerFunctionList = res.data;
        this.filteredFunction.next(this.businessPartnerFunctionList);

        this.filteredFunction.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentCreateInterlocutor.businessPartnerFunctionIds
              .includes(material._id.toString())
          );
          this.functionMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.functionMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterFunctionMulti();
            this.setToggleAllCheckboxState();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error fetching business function',"Cerrar",{ duration: 5000});
      }
    });
  }

  protected filterFunctionMulti() {
    if (!this.businessPartnerFunctionList) {
      return;
    }
    // get the search keyword
    let search = this.functionMultiFilterCtrl.value;
    if (!search) {
      this.filteredFunctionCache = this.businessPartnerFunctionList;
      this.filteredFunction.next(this.businessPartnerFunctionList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredFunctionCache = this.businessPartnerFunctionList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const code = getCode(material); // Obtener el código correctamente
      const codeMatches = code ? code.toLowerCase().indexOf(search) > -1 : false;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredFunction.next(this.filteredFunctionCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredFunction
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.functionMultiCtrl.patchValue(val);
        } else {
          this.functionMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.functionMultiCtrl && this.functionMultiCtrl.value) {
      this.filteredFunctionCache.forEach((el) => {
        if (this.functionMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredFunctionCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredFunctionCache.length;
    }
  }

  private fetchAllBusinessPartner(): void {
    this.businessPartnerFilterCtrl.valueChanges
      .pipe(
        startWith(""),
        debounceTime(400),
        distinctUntilChanged(),
        tap(() => (this.isSearchingBusinessPartner = true)),
        switchMap((search) =>
          this.businessPartnerService.findToComboBoxByCodeOrName(search?.trim() ?? "")
        ),
        takeUntil(this._onDestroy)
      )
      .subscribe({
        next: (res) => {
          this.isSearchingBusinessPartner = false;
          const list = res.data ?? [];
          const selected = this.selectedBusinessPartner;
          const hasSelected = selected && list.some((bp) => bp._id.toString() === selected._id.toString());
          this.businessPartnerList = selected && !hasSelected ? [selected, ...list] : list;
        },
        error: (err) => {
          this.isSearchingBusinessPartner = false;
          this.snackBar.open(err.error.message || 'Error fetching business partner',"Cerrar",{ duration: 5000});
        }
      });
  }

  onBusinessPartnerChange(businessPartnerId: string): void {
    this.selectedBusinessPartner = this.businessPartnerList.find(
      (bp) => bp._id.toString() === businessPartnerId
    );
  }

 

  private initializeInterlocutor(): ICreateInterlocutor {
    return {
      businessPartnerId: '',
      businessPartnerFunctionIds: [],
    };
  }

  save() {
    this.currentCreateInterlocutor.businessPartnerFunctionIds = this.functionMultiCtrl.value.map((fu: BusinessPartnerFunctionAttributes) =>
      fu._id.toString()
    ),
    this.dialogRef.close(this.currentCreateInterlocutor);
  }
}
